import { render, staticRenderFns } from "./AppButtonClear.vue?vue&type=template&id=35720f0b&scoped=true&"
import script from "./AppButtonClear.vue?vue&type=script&lang=js&"
export * from "./AppButtonClear.vue?vue&type=script&lang=js&"
import style0 from "./AppButtonClear.vue?vue&type=style&index=0&id=35720f0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35720f0b",
  null
  
)

export default component.exports